import React, { useEffect, useRef } from "react";
import moment from "moment";
import {
  FiEye,
  FiSearch,
  FiFilter,
  FiToggleLeft,
  FiToggleRight,
  FiCheckCircle,
  FiXCircle,
  FiUser,
  FiCalendar,
  FiTag,
  FiClock,
  FiMessageCircle,
  FiUsers,
  FiImage,
  FiFileText,
  FiGrid,
  FiList,
  FiRefreshCw,
  FiMoreVertical,
  FiArrowUp,
  FiArrowDown,
  FiTrendingUp,
  FiTrendingDown,
  FiAlertCircle,
  FiHash,
} from "react-icons/fi";
import {
  MdOutlineSearch,
  MdOutlineFilter,
  MdOutlineVisibility,
  MdOutlineCategory,
  MdOutlinePerson,
  MdOutlineCalendarToday,
  MdOutlineCheckCircle,
  MdOutlineCancel,
  MdOutlinePending,
  MdOutlineChat,
  MdOutlineComment,
  MdOutlinePeople,
  MdOutlineImage,
  MdOutlineDescription,
} from "react-icons/md";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import ReactPaginate from "react-paginate";
import { CiSearch } from "react-icons/ci";
import { PiUsersThreeLight } from "react-icons/pi";
import SortableHeader from "../../../components/SortableHeader";
import ToggleButton from "../../../components/Atoms/ToggleButton/ToggleButton";

const CommunityTable = ({
  TbaleName,
  setreportCount,
  TbaleHeader,
  handleFilter,
  TbaleData,
  showMenu,
  viewAction,
  handlePageClick,
  offset,
  total,
  size,
  handleOnChange,
  keyWord,
  handleViewUser,
  formType,
  setFormType,
  setAdminToggleData,
  currentSortKey,
  currentSortOrder,
  onSort,
  toggleAdminAction,
}) => {
  const ContentActionRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        ContentActionRef.current &&
        !ContentActionRef.current.contains(event.target)
      ) {
        showMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenu]);

  // Status badge component
  const StatusBadge = ({ isDisabled, onClick }) => {
    const handleOnClick = () => {
      if (!onClick) return;
      onClick();
    };

    if (!isDisabled) {
      return (
        <span
          className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full cursor-pointer hover:bg-emerald-100 transition-colors"
          onClick={handleOnClick}
        >
          <FiCheckCircle className="w-3.5 h-3.5 text-emerald-500" />
          Active
        </span>
      );
    }

    return (
      <span
        className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-rose-700 bg-rose-50 border border-rose-200 rounded-full cursor-pointer hover:bg-rose-100 transition-colors"
        onClick={handleOnClick}
      >
        <FiXCircle className="w-3.5 h-3.5 text-rose-500" />
        Inactive
      </span>
    );
  };

  // Post type badge
  const TypeBadge = ({ type }) => {
    const typeConfig = {
      community: {
        icon: FiUsers,
        color: "text-purple-700 bg-purple-50 border-purple-200",
        label: "Community",
      },
      posts: {
        icon: FiFileText,
        color: "text-blue-700 bg-blue-50 border-blue-200",
        label: "Posts",
      },
      forums: {
        icon: FiMessageCircle,
        color: "text-emerald-700 bg-emerald-50 border-emerald-200",
        label: "Forums",
      },
    };
    const config = typeConfig[type?.toLowerCase()] || {
      icon: FiTag,
      color: "text-gray-700 bg-gray-50 border-gray-200",
      label: type || "N/A",
    };
    const Icon = config.icon;

    return (
      <span
        className={`
        inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-full border
        ${config.color}
      `}
      >
        <Icon className="w-3.5 h-3.5" />
        {config.label}
      </span>
    );
  };

  return (
    <div className="w-full">
      <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
        {/* Header Section */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 p-4 md:p-5 border-b border-gray-100 bg-gradient-to-r from-gray-50/50 to-white">
          <div className="flex items-center gap-3">
            <div className="p-1.5 bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 rounded-lg">
              <FiMessageCircle className="w-4 h-4 text-[#715EFE]" />
            </div>
            <div>
              <h2 className="text-base font-semibold text-gray-800">
                {TbaleName}
              </h2>
              <p className="text-xs text-gray-400 hidden sm:block">
                {TbaleData?.length || 0} discussions
              </p>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
            {/* Search */}
            <div className="relative flex-1 sm:min-w-[180px]">
              <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="text"
                placeholder="Search discussions..."
                className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#715EFE]/20 focus:border-[#715EFE] transition-all duration-200"
                onChange={handleOnChange}
                value={keyWord}
              />
            </div>

            {/* Form Type Filter */}
            <div className="relative min-w-[120px]">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <FiFilter className="text-gray-400 w-4 h-4" />
              </div>
              <select
                onChange={(e) => setFormType(e.target.value)}
                className="appearance-none w-full h-10 pl-9 pr-8 py-2 bg-white border border-gray-200 text-sm text-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#715EFE]/20 focus:border-[#715EFE] transition-all duration-200"
                value={formType}
              >
                <option value={""}>All Types</option>
                <option value={"community"}>Community</option>
                <option value={"posts"}>Posts</option>
                <option value={"forums"}>Forums</option>
              </select>
              <FiClock className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
            </div>

            {/* Report Filter */}
            <div className="relative min-w-[120px]">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <FiAlertCircle className="text-gray-400 w-4 h-4" />
              </div>
              <select
                onChange={(e) => setreportCount(e.target.value)}
                className="appearance-none w-full h-10 pl-9 pr-8 py-2 bg-white border border-gray-200 text-sm text-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#715EFE]/20 focus:border-[#715EFE] transition-all duration-200"
              >
                <option value={"all"}>All Reports</option>
                <option value={"Reported"}>Reported</option>
              </select>
              <FiClock className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-50/80 text-xs font-semibold text-gray-500 uppercase tracking-wider border-b border-gray-100">
                {TbaleHeader.map((heading, index) => {
                  const headerIcons = {
                    "#": null,
                    "Discussion Agenda": FiFileText,
                    "Post Type": FiTag,
                    Expert: FiUser,
                    "Total Comment": FiMessageCircle,
                    "Admin Status": FiToggleLeft,
                    "Created Date": FiCalendar,
                    Action: null,
                  };
                  const Icon = headerIcons[heading.label] || headerIcons[heading.label?.trim()];
                  return (
                    <td key={index} className="px-3 md:px-4 py-3 whitespace-nowrap">
                      <SortableHeader
                        label={heading.label}
                        sortKey={heading.sortKey}
                        currentSortKey={currentSortKey}
                        currentSortOrder={currentSortOrder}
                        onSort={onSort}
                        icon={Icon}
                      />
                    </td>
                  );
                })}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {TbaleData && TbaleData.length > 0 ? (
                TbaleData.map((ele, index) => (
                  <tr
                    key={index}
                    className="hover:bg-gray-50/70 transition-colors duration-150 group"
                  >
                    <td className="px-3 md:px-4 py-3">
                      <span className="text-sm font-medium text-gray-400">
                        {offset + index + 1}
                      </span>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex items-center gap-3">
                        <div className="flex-shrink-0 w-12 h-12 rounded-lg overflow-hidden bg-gray-100 border border-gray-200">
                          <img
                            src={ele?.thumbImgUrl || ele.imgUrl || "/Img/library.png"}
                            alt="img"
                            className="w-full h-full object-cover"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/Img/library.png";
                            }}
                          />
                        </div>
                        <span className="text-sm font-medium text-gray-800 truncate max-w-[120px] md:max-w-[200px]">
                          {ele.title || "Untitled"}
                        </span>
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <TypeBadge type={ele?.form_type} />
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex items-center gap-2.5">
                        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 flex items-center justify-center">
                          <span className="text-xs font-bold text-[#715EFE]">
                            {ele.user?.fullName?.charAt(0)?.toUpperCase() ||
                              "U"}
                          </span>
                        </div>
                        <span className="text-sm text-gray-700 truncate max-w-[80px]">
                          {ele.user?.fullName || "Unknown"}
                        </span>
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex items-center gap-1.5">
                        <FiMessageCircle className="w-3.5 h-3.5 text-[#715EFE]" />
                        <span className="text-sm font-semibold text-gray-700">
                          {ele.totalComment || 0}
                        </span>
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <StatusBadge
                        isDisabled={ele?.isDisableByAdmin}
                        onClick={() =>
                          setAdminToggleData({
                            isOpen: true,
                            data: {
                              id: ele._id,
                              isDisableByAdmin: !ele?.isDisableByAdmin,
                            },
                          })
                        }
                      />
                    </td>

                    <td className="px-3 md:px-4 py-3">
                      <div className="flex flex-col">
                        <span className="text-sm text-gray-700 whitespace-nowrap">
                          {ele.createdAt
                            ? moment(ele.createdAt).format("MMM D, YYYY")
                            : "N/A"}
                        </span>
                        {ele.createdAt && (
                          <span className="text-xs text-gray-400">
                            {moment(ele.createdAt).format("h:mm A")}
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex items-center gap-1">
                        {ele?.form_type?.toUpperCase() === "COMMUNITY" && (
                          <button
                            className="p-1.5 text-purple-400 hover:text-purple-600 hover:bg-purple-50 rounded-lg transition-all duration-200"
                            onClick={() => handleViewUser(ele)}
                            title="View Users"
                          >
                            <FiUsers className="w-4 h-4" />
                          </button>
                        )}
                        <button
                          className="p-1.5 text-blue-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200"
                          onClick={() => viewAction(ele)}
                          title="View Details"
                        >
                          <FiEye className="w-4 h-4" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={TbaleHeader.length}
                    className="px-4 py-12 text-center"
                  >
                    <div className="flex flex-col items-center gap-3">
                      <div className="p-4 bg-gray-50 rounded-full">
                        <FiMessageCircle className="w-10 h-10 text-gray-300" />
                      </div>
                      <p className="text-sm font-medium text-gray-500">
                        No discussions found
                      </p>
                      <p className="text-xs text-gray-400">
                        Try adjusting your search or filters
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {total > 10 && (
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 px-4 py-3 border-t border-gray-100 bg-gray-50/50">
            <div className="text-sm text-gray-500">
              Showing {offset + 1} to {Math.min(offset + size, total)} of{" "}
              {total} entries
            </div>
            <ReactPaginate
              previousLabel={"Prev"}
              nextLabel={"Next"}
              breakLabel={"..."}
              breakClassName={"px-2 text-gray-400"}
              pageCount={Math.ceil(total / size)}
              marginPagesDisplayed={1}
              pageRangeDisplayed={2}
              onPageChange={handlePageClick}
              containerClassName={"flex items-center gap-1"}
              pageClassName={"px-2"}
              pageLinkClassName={
                "px-3 py-1 text-sm text-gray-600 rounded-md hover:bg-[#715EFE]/10 hover:text-[#715EFE] transition-colors duration-200"
              }
              previousClassName={"px-2"}
              previousLinkClassName={
                "px-3 py-1 text-sm text-gray-600 rounded-md hover:bg-[#715EFE]/10 hover:text-[#715EFE] transition-colors duration-200"
              }
              nextClassName={"px-2"}
              nextLinkClassName={
                "px-3 py-1 text-sm text-gray-600 rounded-md hover:bg-[#715EFE]/10 hover:text-[#715EFE] transition-colors duration-200"
              }
              activeClassName={"bg-[#715EFE] text-white rounded-md"}
              activeLinkClassName={
                "bg-[#715EFE] text-white px-3 py-1 rounded-md"
              }
              disabledClassName={"opacity-50 cursor-not-allowed"}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CommunityTable;
